import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  /*
  {
    name: 'id',
    label: i18n('entities.contact.fields.id'),
  },
  */
  {
    name: 'source',
    label: i18n('entities.contact.fields.source'),
  },
  {
    name: 'firstname',
    label: i18n('entities.contact.fields.firstname'),
  },
  {
    name: 'lastname',
    label: i18n('entities.contact.fields.lastname'),
  },
  {
    name: 'email',
    label: i18n('entities.contact.fields.email'),
  },
  {
    name: 'categories',
    label: i18n('entities.contact.fields.categories'),
    render: (value) => value.map(ic => ic.name).join(','),
  },
  {
    name: 'positions',
    label: i18n('entities.contact.fields.positions'),
    render: (value) => value.map(ic => ic.name).join(','),
  },
  {
    name: 'country',
    label: i18n('entities.event.fields.country'),
    render: (value) => value ? value.name : '',
  },
  {
    name: 'countryState',
    label: i18n('entities.event.fields.countryState'),
    render: (value) => value ? value.name : '',
  },
  {
    name: 'zipCode',
    label: i18n('entities.contact.fields.zipCode'),
  },
  {
    name: 'mobile',
    label: i18n('entities.contact.fields.mobile'),
  },
  {
    name: 'weightUnit',
    label: i18n('entities.contact.fields.weightUnit'),
  },  
  {
    name: 'weight',
    label: i18n('entities.contact.fields.weight'),
  },  
  {
    name: 'gender',
    label: i18n('entities.contact.fields.gender'),
  },  
  {
    name: 'createdAt',
    label: i18n('entities.contact.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  /* 
  {
    name: 'updatedAt',
    label: i18n('entities.contact.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
  */
];
